import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Grid
} from '@mui/material';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

const AppointmentModal = ({ open, onClose, onSubmit, initialData = {} }) => {
    const [formData, setFormData] = useState({
        doctorEmployeeId: initialData.doctorEmployeeId || '',
        appointDate: initialData.appointDate ? dayjs(initialData.appointDate) : null,
        appointTime: initialData.appointTime ? dayjs(initialData.appointTime, 'HH:mm') : null,
        healthCareProviderId: initialData.healthCareProviderId || '',
        description: initialData.description || '',
        rescheduleReason: initialData.rescheduleReason || '',
        id: initialData.id || 0,
      });


  const handleChange = (field, value) => {
    if((field === "appointDate") || (field === "appointTime")){
        setFormData(prev => ({
            ...prev,
            [field]: dayjs(value),
          }));
    }
    else{
          setFormData(prev => ({
      ...prev,
      [field]: value,
    }));
    }
  };

  const handleSubmit = () => {
    const payload = {
      ...formData,
      appointDate: dayjs(formData.appointDate).format('YYYY/MM/DD'),
      appointTime: dayjs(formData.appointTime).format('HH:mm'),
    };
    onSubmit(payload);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Appointment</DialogTitle>
      <DialogContent>
          <Grid container spacing={2} mt={1}>
            <Grid item xs={6}>
              <DatePicker
                label="Appointment Date"
                value={formData.appointDate}
                onChange={value => handleChange('appointDate', value)}
                format="YYYY/MM/DD"
                slotProps={{ textField: { fullWidth: true } }}
              />
            </Grid>
            <Grid item xs={6}>
              <TimePicker
                label="Appointment Time"
                value={formData.appointTime}
                onChange={value => handleChange('appointTime', value)}
                format="HH:mm"
                slotProps={{ textField: { fullWidth: true } }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Description"
                fullWidth
                multiline
                rows={3}
                value={formData.description}
                onChange={e => handleChange('description', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Reschedule Reason"
                fullWidth
                multiline
                rows={2}
                value={formData.rescheduleReason}
                onChange={e => handleChange('rescheduleReason', e.target.value)}
              />
            </Grid>
          </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">Submit</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppointmentModal;
